import { render, staticRenderFns } from "./Saletrade.vue?vue&type=template&id=2631b67c&scoped=true"
import script from "./Saletrade.vue?vue&type=script&lang=js"
export * from "./Saletrade.vue?vue&type=script&lang=js"
import style0 from "./Saletrade.vue?vue&type=style&index=0&id=2631b67c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2631b67c",
  null
  
)

export default component.exports